var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "线索id" },
                                  model: {
                                    value: _vm.form.merchant_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "merchant_id", $$v)
                                    },
                                    expression: "form.merchant_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "公司名称" },
                                  model: {
                                    value: _vm.form.company,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "company", $$v)
                                    },
                                    expression: "form.company"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "手机号" },
                                  model: {
                                    value: _vm.form.mobile,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "mobile", $$v)
                                    },
                                    expression: "form.mobile"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "意向商家来源" },
                                    model: {
                                      value: _vm.form.source,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "source", $$v)
                                      },
                                      expression: "form.source"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.ops.source, function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          value: item.value,
                                          label: item.label
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "商家跟进状态" },
                                    model: {
                                      value: _vm.form.follow_up_status,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "follow_up_status",
                                          $$v
                                        )
                                      },
                                      expression: "form.follow_up_status"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.ops.follow_up_status, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          value: item.value,
                                          label: item.label
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "是否入驻" },
                                    model: {
                                      value: _vm.form.is_settle_in,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_settle_in", $$v)
                                      },
                                      expression: "form.is_settle_in"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.ops.is_settle_in, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          value: item.value,
                                          label: item.label
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "支持无理由退换货" },
                                    model: {
                                      value: _vm.form.no_reason_return,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "no_reason_return",
                                          $$v
                                        )
                                      },
                                      expression: "form.no_reason_return"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.ops.no_reason_return, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          value: item.value,
                                          label: item.label
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "申请时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "default-time": ["00:00:00", "23:59:59"],
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_time", $$v)
                                    },
                                    expression: "form.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "" },
                                    on: { click: _vm.reset }
                                  },
                                  [_vm._v("重置")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { border: "1px solid #ddd" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "50px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: { slot: "trigger", size: "mini", type: "success" },
                      on: { click: _vm.exportExcel },
                      slot: "trigger"
                    },
                    [_vm._v("导出")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "0" } },
                [
                  _vm.resData
                    ? _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading"
                            }
                          ],
                          ref: "multipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            height: "800",
                            data: _vm.resData.list,
                            "tooltip-effect": "dark",
                            "cell-class-name": _vm.addColor
                          },
                          on: { "selection-change": _vm.handleSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "merchant_id",
                              label: "线索id"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "create_time",
                              label: "申请时间"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "source",
                              label: "意向商家来源"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "contract",
                              label: "姓名"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "mobile",
                              label: "联系方式"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "company",
                              label: "公司名称"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "company_address",
                              label: "公司地址"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "stall_address",
                              label: "档口地址"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "",
                              label: "营业执照"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          "max-width": "80px",
                                          "max-height": "80px"
                                        },
                                        attrs: {
                                          src: scope.row.license_pic,
                                          alt: ""
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1183924626
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "style",
                              label: "主打风格"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "main_category",
                              label: "主营类目"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "category",
                              label: "类目"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "own_factory_num",
                              label: "自有工厂数量"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "oem_factory_num",
                              label: "外包工厂数量"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "month_new_num",
                              label: "月上新量"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "designer_num",
                              label: "设计师团队人数"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "annual_sales",
                              label: "年成交 GMV"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "dev_ability",
                              label: "开发能力"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "no_reason_return",
                              label: "无理由退换货"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "电商经营经验",
                              prop: "is_ecommerce_operate_experience"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "ecommerce_operate_platform",
                              label: "电商经营平台"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "",
                              label: "工厂视频"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("video", {
                                        staticStyle: {
                                          "max-width": "80px",
                                          "max-height": "80px"
                                        },
                                        attrs: {
                                          src: scope.row.factory_video,
                                          preload: "metadata"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.open(
                                              scope.row.factory_video
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              742420861
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "",
                              label: "办公室视频"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("video", {
                                        staticStyle: {
                                          "max-width": "80px",
                                          "max-height": "80px"
                                        },
                                        attrs: {
                                          src: scope.row.office_video,
                                          preload: "metadata"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.open(
                                              scope.row.office_video
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2960780509
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "",
                              label: "商品1"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          "max-width": "80px",
                                          "max-height": "80px"
                                        },
                                        attrs: {
                                          src: scope.row.product_pic1,
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(_vm._s(scope.row.product_price1))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3269195441
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "",
                              label: "商品2"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          "max-width": "80px",
                                          "max-height": "80px"
                                        },
                                        attrs: {
                                          src: scope.row.product_pic2,
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(_vm._s(scope.row.product_price2))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3561710417
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "",
                              label: "商品3"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          "max-width": "80px",
                                          "max-height": "80px"
                                        },
                                        attrs: {
                                          src: scope.row.product_pic3,
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(_vm._s(scope.row.product_price3))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              872841969
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "",
                              label: "商品4"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          "max-width": "80px",
                                          "max-height": "80px"
                                        },
                                        attrs: {
                                          src: scope.row.product_pic4,
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(_vm._s(scope.row.product_price4))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              686667665
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "",
                              label: "商品5"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          "max-width": "80px",
                                          "max-height": "80px"
                                        },
                                        attrs: {
                                          src: scope.row.product_pic5,
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(_vm._s(scope.row.product_price5))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              232675377
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "follow_up_status",
                              label: "跟进状态"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "follow_up_admin_name",
                              label: "跟进人"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "follow_up_msg",
                              label: "跟进信息"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "remark",
                              label: "原因备注"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作",
                              fixed: "right"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      ["1"].includes(
                                        scope.row.follow_up_status_int
                                      )
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "mini"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.followUp(
                                                        scope.row.merchant_id
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("跟进")]
                                              ),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "danger",
                                                    size: "mini"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.stopFollowUp(
                                                        "unFollowUp",
                                                        0,
                                                        scope.row.merchant_id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "不跟进\n                "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      ["2"].includes(
                                        scope.row.follow_up_status_int
                                      )
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "success",
                                                    size: "mini"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getFollowMsg(
                                                        scope.row.merchant_id,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("记录跟进情况")]
                                              ),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "success",
                                                    size: "mini"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.stopFollowUp(
                                                        "finishFollowUp",
                                                        0,
                                                        scope.row.merchant_id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "完成跟进\n                "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      ["3"].includes(
                                        scope.row.follow_up_status_int
                                      )
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "mini"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getFollowMsg(
                                                        scope.row.merchant_id,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("查看跟进信息")]
                                              ),
                                              _c("br")
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              799601245
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.resData
                ? _c(
                    "div",
                    { staticStyle: { "text-align": "right", padding: "25px" } },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.curPage,
                          background: "",
                          layout: "total, prev, pager, next, jumper ,sizes",
                          total: _vm.resData.count,
                          "page-size": _vm.form.pagesize,
                          "page-sizes": [10, 50, 100, 200, 500, 1000]
                        },
                        on: {
                          "update:currentPage": function($event) {
                            _vm.curPage = $event
                          },
                          "update:current-page": function($event) {
                            _vm.curPage = $event
                          },
                          "current-change": _vm.handleCurrentChange,
                          "size-change": _vm.handleSizeChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: _vm.followUpTitle,
                    visible: _vm.followUpVisible,
                    width: "40%"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.followUpVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.followUpForm } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            staticClass: "comment",
                            attrs: {
                              type: "textarea",
                              rows: 9,
                              placeholder: "请输入备注信息"
                            },
                            model: {
                              value: _vm.followUpForm.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.followUpForm, "remark", $$v)
                              },
                              expression: "followUpForm.remark"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商家是否入驻: " } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.followUpForm.is_settle_in,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.followUpForm,
                                    "is_settle_in",
                                    $$v
                                  )
                                },
                                expression: "followUpForm.is_settle_in"
                              }
                            },
                            [_vm._v("\n              是")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              model: {
                                value: _vm.followUpForm.is_settle_in,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.followUpForm,
                                    "is_settle_in",
                                    $$v
                                  )
                                },
                                expression: "followUpForm.is_settle_in"
                              }
                            },
                            [_vm._v("\n              否")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.followUpVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.stopFollowUp("", 1)
                            }
                          }
                        },
                        [_vm._v("\n            确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: _vm.followUpMsgTitle,
                    visible: _vm.followUpMsgVisible,
                    width: "40%"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.followUpMsgVisible = $event
                    }
                  }
                },
                [
                  _vm.followUpMsgInput
                    ? _c(
                        "el-form",
                        { attrs: { model: _vm.followUpMsgForm } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                staticClass: "comment",
                                attrs: {
                                  type: "textarea",
                                  rows: 9,
                                  placeholder: "请输入最新跟进情况"
                                },
                                model: {
                                  value: _vm.followUpMsgForm.msg,
                                  callback: function($$v) {
                                    _vm.$set(_vm.followUpMsgForm, "msg", $$v)
                                  },
                                  expression: "followUpMsgForm.msg"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-timeline",
                    _vm._l(_vm.followMsgs, function(msg, index) {
                      return _c(
                        "el-timeline-item",
                        {
                          key: index,
                          attrs: { reverse: "true", timestamp: msg.time }
                        },
                        [
                          _vm._v(
                            "\n            " + _vm._s(msg.msg) + "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.followUpMsgVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.saveFollowMsg()
                            }
                          }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7170a99a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7170a99a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/merchants/index.vue
// module id = null
// module chunks = 